import { MouseEvent, ReactNode, useCallback, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { wrapper } from './wrapper-helper';
import { CurrentFileBlob, XlsxFile, RangeSelection, SheetDataResult } from './UpdateReferenceData';
import { StyledDataSheet } from 'app/components';
import { autoScrollWhileDragging } from './dragAutoScroll';

interface SelectRangeProps {
  sheetData: SheetDataResult;
  setSelection: (selection: RangeSelection) => void;
  maybeFile?: XlsxFile;
  maybeSheet?: string;
  onNewFileClick: () => void;
  onChooseSheetClick: () => void;
  onAbortClick: () => void;
  onSaveSelectionClick: () => void;
  notice?: ReactNode;
}

export function SelectRange(props: SelectRangeProps) {
  const { t } = useTranslation(['common', 'reference-data']);

  const { sheetData, setSelection, maybeFile, maybeSheet, onNewFileClick, onChooseSheetClick, onAbortClick, onSaveSelectionClick, notice = null } = props;

  const handleRangeSelect = useCallback(
    (selection: RangeSelection) => {
      setSelection({
        ...selection,
        sheet: maybeSheet,
      });
    },
    [maybeSheet, setSelection]
  );

  const stopAutoScroll = useRef(() => {});
  useEffect(() => () => stopAutoScroll.current(), []);
  const handleGridMouseDown = (e: MouseEvent<HTMLDivElement>) => {
    stopAutoScroll.current();
    stopAutoScroll.current = autoScrollWhileDragging(e.currentTarget.closest<HTMLElement>('.overflow-auto'), e);
  };

  const grid = sheetData.data ?? [];

  return wrapper(
    t('reference-data:update-selection.modal.title'),
    [sheetData],
    () => (
      <>
        <CurrentFileBlob file={maybeFile}>
          <div onClick={onNewFileClick}>{t('reference-data:update-sheet.link.choose-new-file')}</div>
          <div onClick={onChooseSheetClick}>{t('reference-data:choose-sheet')}</div>
        </CurrentFileBlob>
        <div className="flex">
          <div
            className="data-sheet-fixed-wrapper"
            style={{
              width: (grid[0]?.length ?? 0) * 100 + 'px',
              height: grid.length * 20 + 'px',
            }}
            onMouseDown={handleGridMouseDown}
          >
            <StyledDataSheet data={grid} onSelect={handleRangeSelect} disablePageClick />
          </div>
        </div>
      </>
    ),
    () => (
      <>
        <div className="modal-btn-group">
          <button className="button clear" onClick={onAbortClick}>
            {t('common:cancel')}
          </button>
          <button className="button primary" onClick={onSaveSelectionClick}>
            {t('reference-data:update-selection.save')}
          </button>
        </div>
      </>
    ),
    notice
  );
}
